/* global sessionStorage */
/**
 * An effect plugin for effortlessly storing/fetching atoms to/from session storage
 *
 * @param {string} key
 * @returns {Function}
 */
const sessionStorageEffect = (key) => ({ setSelf, onSet }) => {
  const savedValue = sessionStorage.getItem(key);
  if (savedValue) {
    setSelf(savedValue);
  }

  onSet((newValue, _, isReset) => {
    if (isReset) {
      return sessionStorage.removeItem(key);
    }
    return sessionStorage.setItem(key, newValue);
  });
};

export default sessionStorageEffect;
